export default "__VITE_PUBLIC_ASSET__db8c9abe__"